import { FC } from 'react';

import { FieldValues, UseFormReturn } from 'react-hook-form';

import RichText from '@components/RichText/RichText';
import { SmartHomeBatteryRendering } from '@sitecore/types/SmartHomeBattery';
import { CheckboxGroup, CheckTile, Heading } from '@sparky';
import { ElectricCar, Heatpump, Radiator, SwimmingPool } from '@sparky/illustrations';

const Step2: FC<{
  fields: SmartHomeBatteryRendering['fields'];
  formMethods: UseFormReturn<FieldValues, undefined>;
}> = ({ fields, formMethods }) => {
  const { register } = formMethods;
  return (
    <>
      <Heading as="h2" size="M">
        {fields.step2Title.value}
      </Heading>
      <Heading as="h3" size="S">
        {fields.step2Subtitle.value}
      </Heading>
      <RichText html={fields.step2BodyContent.value} />
      <CheckboxGroup label="">
        <CheckTile
          icon={<ElectricCar size="small" />}
          {...register('hasEV')}
          subtitle={fields.step2FieldsHasEvHintText.value}>
          {fields.step2FieldsHasEvLabel.value}
        </CheckTile>
        <CheckTile
          icon={<Heatpump size="small" />}
          {...register('hasHeatPump')}
          subtitle={fields.step2FieldsHasHeatPumpHintText.value}>
          {fields.step2FieldsHasHeatPumpLabel.value}
        </CheckTile>
        <CheckTile
          icon={<Radiator size="small" />}
          {...register('hasElecHeating')}
          subtitle={fields.step2FieldsHasElecHeatingHintText.value}>
          {fields.step2FieldsHasElecHeatingLabel.value}
        </CheckTile>
        <CheckTile
          icon={<SwimmingPool size="small" />}
          {...register('hasSwimPool')}
          subtitle={fields.step2FieldsHasSwimPoolHintText.value}>
          {fields.step2FieldsHasSwimPoolLabel.value}
        </CheckTile>
      </CheckboxGroup>
    </>
  );
};

export default Step2;
